<template>
	<az-container>
		<cabecalho-anuencia
			:anuencia="anuencia"
			@abrir-modal-recusar="abrirModalRecusar"
			@aceitar-itens="aceitarItensAnuencia"
			@gerar-documento="gerarDocumento"
		></cabecalho-anuencia>
		<az-container>
			<v-data-table :items="itens" hide-default-footer :headers="colunas">
				<template #item.descricao="{ item }">
					<texto-tooltip :texto="item.descricao" :tamanho-maximo="200"></texto-tooltip>
				</template>
				<template #header.qtdSolicitada="{ header }">
					<span class="d-flex align-end justify-end">{{ header.text }}</span>
				</template>
				<template #item.qtdSolicitada="{ item }">
					<span class="d-flex align-end justify-end">{{ item.qtdSolicitada | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}</span>
				</template>
			</v-data-table>
			<paginacao-tabela
				v-if="totalItens > 0"
				:page.sync="paginacaoInterna.page"
				:rows-per-page.sync="paginacaoInterna.rowsPerPage"
				:totalPaginas="totalPaginas"
				:totalItens="totalItens"
				@resetar-page="resetarPaginacao"
			></paginacao-tabela>
		</az-container>

		<modal
			:exibir="exibirModalRecusar"
			titulo="Recusa de Adesão"
			max-width="600"
			:custom-actions="false"
			:acao-cancelar="fecharModalRecusar"
			@close="fecharModalRecusar"
			:acao-confirmar="recusarAdesao"
			nome-botao-confirmar="Enviar"
			:is-confirmar-desabilitado="!formRecusarIsValid"
			is-confirmar-visivel
		>
			<template #body>
				<div class="mx-2 my-5">
					<div class="az-text arp-label-personalizado estilo-msg-recusar">
						<v-icon class="arp-icon-no-data mb-1 mr-1" size="17" color="warning">mdi-alert-circle</v-icon>
						Ao recusar os itens você será redirecionado para a finalização.
					</div>
					<v-form lazy-validation ref="formRecusar" v-model="formRecusarIsValid">
						<label-personalizado
							nome-campo="Motivo da Recusa"
							obrigatorio-por-padrao
							class="mt-2"
						></label-personalizado>
						<v-textarea counter rows="5" :rules="justificativaRule" v-model="justificativa"></v-textarea>
					</v-form>
				</div>
			</template>
		</modal>
	</az-container>
</template>
<script>
import { PaginacaoListagemUtils, TabelaColunaUtils } from '@/core/utils'
import { actionTypes } from '@/core/constants'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import descriptografaHash from '@/views/pages/adesao/anuenciaFornecedor/mixin/DescriptografaHash'
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import cabecalhoAnuencia from '@/views/pages/adesao/anuenciaFornecedor/components/cabecalho/CabecalhoAnuencia.vue'
import buscarAnuencia from '@/views/pages/adesao/anuenciaFornecedor/mixin/buscar-anuencia-mixin'

export default {
	name: 'etapa-itens-anuencia',
	components: { Modal, LabelPersonalizado, TextoTooltip, cabecalhoAnuencia },
	mixins: [descriptografaHash, buscarAnuencia],
	data() {
		return {
			exibirModalRecusar: false,
			formRecusarIsValid: false,
			totalPaginas: 0,
			totalItens: 0,
			paginacaoInterna: new PaginacaoListagemUtils('id', 5, 'asc'),
			colunas: [
				new TabelaColunaUtils('Tipo', 'tipo', '10%'),
				new TabelaColunaUtils('Descrição', 'descricao', '70%'),
				new TabelaColunaUtils('Qtd. Solicitada', 'qtdSolicitada', '20%'),
			],
			justificativa: null,
			justificativaRule: [(v) => !!v || 'O motivo da recusa é obrigatório.'],
			itens: [],
			anuencia: {},
		}
	},
	computed: {
		numeroCasasDecimaisQtde: {
			get() {
				return this.$store.state.casasDecimais.numeroCasasDecimaisQtde
			},
		},
	},
	watch: {
		paginacaoInterna: {
			async handler() {
				await this.buscarItensParaAnuencia()
			},
			deep: true,
		},
	},
	async mounted() {
		await this.buscarItensParaAnuencia()
		this.mostrarNotificacaoSucesso('Itens carregados com sucesso!')
	},
	methods: {
		async gerarDocumento() {
			try {
				await this.$store.dispatch(actionTypes.ITEM_ADESAO.GERAR_DOCUMENTO, {
					idEmailAdesaoFornec: this.getControleAnuencia(),
				})

				await this.buscarDadosCabecalho()
				this.mostrarNotificacaoSucesso('Documento gerado com sucesso!')
				this.$emit('ir-para-assinatura')
			} finally {
				await this.buscarDadosCabecalho()
				this.$emit('atualizar-steper')
			}
		},
		async buscarItensParaAnuencia() {
			let response = await this.$store.dispatch(actionTypes.ITEM_ADESAO.BUSCAR_ITENS_PARA_ANUENCIA, {
				id: this.getControleAnuencia(),
				paginacao: this.paginacaoInterna,
			})
			this.itens = response.itens
			this.totalPaginas = response.totalPages
			this.totalItens = response.totalElements
		},
		async recusarAdesao() {
			if (this.$refs.formRecusar.validate()) {
				try {
					await this.$store.dispatch(actionTypes.ITEM_ADESAO.RECUSAR_ITEM, {
						idEmailAdesaoFornec: this.getControleAnuencia(),
						justificativa: this.justificativa,
					})

					await this.buscarDadosCabecalho()

					this.mostrarNotificacaoSucesso('Adesão recusada com sucesso!')
					this.fecharModalRecusar()
					this.$emit('ir-para-finalizar')
				} finally {
					await this.buscarDadosCabecalho()
					this.$emit('atualizar-steper')
				}
			}
		},
		async resetarPaginacao() {
			this.paginacaoInterna.page = 1
			await this.buscarItensParaAnuencia()
		},
		abrirModalRecusar() {
			this.exibirModalRecusar = true
		},
		fecharModalRecusar() {
			this.exibirModalRecusar = false
		},
		async aceitarItensAnuencia() {
			try {
				await this.$store.dispatch(actionTypes.ITEM_ADESAO.ACEITAR_ITEM, {
					idEmailAdesaoFornec: this.getControleAnuencia(),
				})

				await this.buscarDadosCabecalho()
				this.mostrarNotificacaoSucesso('Adesão aceita com sucesso!')
				this.$emit('ir-para-assinatura')
			} finally {
				await this.buscarDadosCabecalho()
				this.$emit('atualizar-steper')
			}
		},
	},
}
</script>
<style scoped lang="stylus"></style>
